import { Layout } from "../UI/Layout/Layout.tsx";
import { NavBar } from "../UI/Layout/NavBar.tsx";
export const NotHavePermissionToSeePageScreenPath =
  "/not-have-permission-to-see-page";
export function NotHavePermissionToSeePageScreen() {
  return (
    <Layout>
      <NavBar />
      <div className={"p-4 flex flex-1 items-center justify-center"}>
        <div className={"bg-white shadow-md p-4 rounded-2xl space-y-2"}>
          <h1 className={"font-bold text-2xl text-center"}>Ops 🥹</h1>
          <p className={"text-center"}>
            Non hai i permessi per vedere questa pagina.
          </p>
        </div>
      </div>
    </Layout>
  );
}
